import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';

/**
 * `<labs-avatar>` displays an avatar image with an optional status indicator.
 */
@Component({
  selector: 'labs-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
  @Input() src: string;

  @Input() alt: string;

  @HostBinding('class')
  @Input()
  size?: 'sm' | 'md' | 'lg' = 'sm';

  @Input()
  statusVisible = false;
}
